import { useState } from "react";
import { useStateValue } from "../../state";
import { Col, Form, Input, notification } from "antd";
import api from "../../services/api";
import { listagemActions, manutencaoActions } from "../../actions";

export default function ManutencaoTipoServico({ formulario, carregando, aoSalvar }) {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [loading, setLoading] = useState(false);
    const [hover, setHover] = useState(false);
    const [fileList, setFileList] = useState([]);

    const salvarManutencao = (values) => {
        carregando(true);
        let retorno;

        let enderecoUrl = 'TipoServico/';

        if (values.tse_id) {
            enderecoUrl += `Editar`;
            api.put(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: 'Operação concluída', description: "As novas configurações foram salvas com sucesso!" });
                    retorno = res.data;
                }
            }, err => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(err.response) });
            }).finally(
                () => {
                    carregando(false);
                    aoSalvar(retorno);
                    setFileList([]);
                })
        } else {
            enderecoUrl += `Incluir`;
            api.post(enderecoUrl, values).then(res => {
                if (res.status === 200) {
                    notification.success({ message: 'Operação concluída', description: "As configurações foram incluidas com sucesso!" });
                    retorno = res.data;
                    dispatch({ type: manutencaoActions.CHANGE, data: { dados: res.data } });
                }
            }, err => {
                notification.error({ message: 'Erro ao processar a requisição.', description: JSON.stringify(err.response) });
            }).finally(
                () => {
                    carregando(false);
                    aoSalvar(retorno);
                    dispatch({ type: listagemActions.CHANGE, data: { ordem: '+tse_id' } });
                }
            );
        }
    }

    return (
        <Form layout="vertical" form={formulario} name="ManutencaoTipoServico" onFinish={salvarManutencao}>

            <Form.Item name="tse_id" hidden={true}> <Input />
            </Form.Item>

            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <Form.Item label="Descrição" name="tse_descricao" rules={[{ required: true, message: 'Informe a Descrição do Tipo de Serviço' },]}>
                    <Input placeholder="Informe a Descrição do Tipo de Serviço" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                <Form.Item label="Validade (em dias)" name="tse_validade" rules={[
                    { required: true, message: "Informe o prazo de validade" },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || (Number(value) >= 0 && Number(value) <= 31)) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error("Informe um número entre 0 e 31"));
                        },
                    }),
                ]}
                >
                    <Input placeholder="Informe o prazo de validade" />
                </Form.Item>
            </Col>

        </Form >
    );

}